import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Modal, Table } from 'rsuite'
import Select from 'react-select'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import { createSupplierBasicInfo, createSupplierCardInfo, createSupplierPaymentInfo, getAllListSupplierInfo, linkUnlinkedCallToVendor, updateSupplierBasicInfo, updateSupplierCardInfo, updateSupplierPaymentInfo, getCallRecordings, removeUnlinkedSupplierCallDetails, updateUnlinkedCallSupplierDetails } from '../../../../redux/actions/caller'
import { checkIsEmailValid, checkIsPhoneNumberValid, findDuplicateEmails, getAbbreviatedState } from '../../../../services/helper'
import BasicInfo from './basicInfo'
import CardInfo from './cardInfo'
import CheckInfo from './checkInfo'
import AchInfo from './achInfo'
import { addCardAcceptanceEmails, checkEmployerIdNumberExists, uploadAchInstruction, uploadCardAuthorizationFormFile, getCardAcceptanceFee, getCardAcceptanceEmails, getHistoryData } from '../../../../redux/actions/vendor'
import LoaderComponent from '../../../CommonComponents/LoaderComponent'

const LinkToVendorDetailsModal = ({ show, onClose, vendorInfo, vendorId, callDetails }) => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const history = useHistory()

    const {
        user: {
            users
        },
        domain: {
            currentDomain,
        },
        auth: { user },
        app: {
            createSupplierBasicColumns,
            createSupplierCardColumns,
        }
    } = store

    const { id } = user
    const multiSelectColumns = ['productSpecificOptions', 'emailRemitRequirements', 'phoneRemitRequirements', 'faxRemitRequirements', 'onlineRemitRequirements', 'posRemitRequirements']
    const infoOptions = [
        { label: 'Call Information', value: 'call' },
        { label: 'List Master Information', value: 'listMaster' }
    ]
    const tabs = [
        { label: 'Supplier Info', value: 'basic' },
        { label: 'Card Acceptance', value: 'card' },
        { label: 'Check Acceptance', value: 'check' },
        { label: 'ACH Acceptance', value: 'ach' }
    ]


    const defaultCardFeeInfo = {
        showHideFee: {
            showAmexMinFee: false,
            showAmexMaxFee: false,
            showAmexIncrementalFee: false,
            showVisaMinFee: false,
            showVisaMaxFee: false,
            showVisaIncrementalFee: false,
            showMasterMinFee: false,
            showMasterMaxFee: false,
            showMasterIncrementalFee: false,
            showDiscoverMinFee: false,
            showDiscoverMaxFee: false,
            showDiscoverIncrementalFee: false,
            showAmexSecondProcessingFee: false,
            showVisaSecondProcessingFee: false,
            showMasterSecondProcessingFee: false,
            showDiscoverSecondProcessingFee: false
        }
    }

    const defaultGenericFeeValues = {
        showMinFee: false,
        showMaxFee: false,
        showIncrementalFee: false,
        showAnotherProcessingFee: false,
        showCreditCards: null,
        processingFeeType: '$',
        processingFeeValue: '',
        processingSecondFeeType: '$',
        processingSecondFeeValue: '',
        minFeeType: '$',
        minFeeValue: '',
        maxFeeType: '$',
        maxFeeValue: '',
        incrementalFeeType: '$',
        incrementalFeeValue: '',
        minPayment: '',
        maxPayment: '',
        incrementalPayment: '',
        showVariableFee: null
    }

    useEffect(() => {
        if (!vendorInfo?.value) {
            return
        }
        dispatch(getAllListSupplierInfo({ listSupplierId: null, vendorInCallsDetailsId: callDetails?.id })).then(async (callData) => {
            const cardInfo = {}
            callData['cardFeeData'] = await dispatch(getCardAcceptanceFee(null, callDetails?.id, true))
            callData['cardEmails'] = await dispatch(getCardAcceptanceEmails(null, callDetails?.id, true))
            setCallCardInfo(cardInfo)
            setCallAchInfo(callData?.paymentInfo)
            setCallCheckInfo(callData?.paymentInfo)
            setCallData(callData)
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed to get call data!',
            })
        })
        dispatch(getAllListSupplierInfo({ listSupplierId: vendorInfo?.value, vendorInCallsDetailsId: null })).then(async (vendorData) => {
            vendorData['cardFeeData'] = await dispatch(getCardAcceptanceFee(vendorInfo?.value, null, true))
            vendorData['cardEmails'] = await dispatch(getCardAcceptanceEmails(vendorInfo?.value, null, true))
            setListMasterData(vendorData)
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed to get call data!',
            })
        })
    }, [])

    const [isSavingData, setIsSavingData] = useState(false)
    const [selectedInfo, setSelectedInfo] = useState({ label: 'Call Information', value: 'call' })
    const [currentTab, setCurrentTab] = useState('basic')
    const [callData, setCallData] = useState([])
    const [listMasterData, setListMasterData] = useState([])
    const [emailValues, setEmailValues] = useState([]);
    const [newEmailValues, setNewEmailValues] = useState([]);
    const [basicInfo, setBasicInfo] = useState({})
    const [callBasicInfo, setCallBasicInfo] = useState({})
    const [cardInfo, setCardInfo] = useState({})
    const [callCardInfo, setCallCardInfo] = useState({})
    const [achInfo, setAchInfo] = useState({})
    const [callAchInfo, setCallAchInfo] = useState({})
    const [checkInfo, setCheckInfo] = useState({})
    const [callCheckInfo, setCallCheckInfo] = useState({})
    const [achInstructionFile, setAchInstructionFile] = useState(null)
    const [cardAuthorizationFormFile, setCardAuthorizationFormFile] = useState(null)
    const [addCardEmailValues, setAddCardEmailValues] = useState({})
    const [supplierPrimaryCardEmail, setSupplierPrimaryCardEmail] = useState('')
    const [addedEmailValues, setAddedEmailValues] = useState([])
    const [isPhoneValid, setIsPhoneValid] = useState('')
    const [isFaxValid, setIsFaxValid] = useState(true)
    const [isBasicPhoneValid, setIsBasicPhoneValid] = useState('')
    const [isBasicFaxValid, setIsBasicFaxValid] = useState(true)
    const [isNaicsValid, setIsNaicsValid] = useState(true)
    const [isSicValid, setIsSicValid] = useState(true)
    const [progress, setProgress] = useState(0)
    const [cardEmailType, setcardEmailType] = useState('')
    const [isValidatingBasicPhone, setIsValidatingBasicPhone] = useState(false)
    const [isValidatingCardPhone, setIsValidatingCardPhone] = useState(false)
    const [isEmailValid, setIsEmailValid] = useState('')
    const [isValidatingCardEmail, setIsValidatingCardEmail] = useState(false)
    const [isBasicEmailValid, setIsBasicEmailValid] = useState('')
    const [isValidatingBasicEmail, setIsValidatingBasicEmail] = useState(false)
    const [isBasicEmailRisky, setIsBasicEmailRisky] = useState('')
    const [isAchEmailValid, setIsAchEmailValid] = useState('')
    const [isValidatingAchEmail, setIsValidatingAchEmail] = useState(false)
    const [isAchEmailRisky, setIsAchEmailRisky] = useState('')
    const [basicPhoneCountryCode, setBasicPhoneCountryCode] = useState('')
    const [cardPhoneCountryCode, setCardPhoneCountryCode] = useState('')
    const [deliveryMethodsFeeValues, setDeliveryMethodsFeeValues] = useState({})
    const [cardFeeInfo, setCardFeeInfo] = useState(defaultCardFeeInfo)
    const [showAcceptancePerCard, setShowAcceptancePerCard] = useState(false)
    const [showListMasterAcceptancePerCard, setShowListMasterAcceptancePerCard] = useState(false)
    const [accPerCardText, setAccPerCardText] = useState('Acceptance Per Card')
    const [listMasterAccPerCardText, setListMasterAccPerCardText] = useState('Acceptance Per Card')
    const [isPortalUrlValid, setIsPortalUrlValid] = useState(true)
    const [isThirdPartyPortalUrlValid, setIsThirdPartyPortalUrlValid] = useState(true)
    const [isIVRPhoneValid, setIsIVRPhoneValid] = useState('')
    const [isValidatingIVRPhone, setIsValidatingIVRPhone] = useState(false)
    const [ivrCountryCode, setIVRCountryCode] = useState('')
    const [genericFeeValues, setGenericFeeValues] = useState(defaultGenericFeeValues)
    const [listMasterGenericFeeValues, setListMasterGenericFeeValues] = useState(defaultGenericFeeValues)

    const setInitialSupplierInfo = useCallback(async (columns, supplierBasicInfo, listSupplierInfo) => {
        let tmpChildBasicInfo = {}
        let tmpBasicInfo = {}
        var phoneNumber = ''
        let stateCode = ''
        let supplierColumns = [...columns]
        supplierColumns.push({ name: 'phoneExtension', label: 'Phone Extension' })
        supplierColumns.forEach(async (column) => {
            if (supplierBasicInfo && column.name === 'abbreviatedState') {
                stateCode = getAbbreviatedState('', supplierBasicInfo?.state)
                supplierBasicInfo['abbreviatedState'] = stateCode
            }

            if ((supplierBasicInfo || listSupplierInfo) && column.name === 'phone') {
                var phone = !supplierBasicInfo?.[column.name] ? '' : supplierBasicInfo?.[column.name]?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? supplierBasicInfo?.[column.name] : supplierBasicInfo?.['country'] && supplierBasicInfo?.['country'].toLowerCase() === 'united states' && supplierBasicInfo?.[column.name].startsWith('1') ? supplierBasicInfo?.[column.name] : ((supplierBasicInfo?.['country'] && supplierBasicInfo?.['country'].toLowerCase() !== 'united states')) ? supplierBasicInfo?.[column.name] : supplierBasicInfo?.[column.name].startsWith('1') ? supplierBasicInfo?.[column.name] : '1 ' + supplierBasicInfo?.[column.name]

                var listSupPhone = !listSupplierInfo?.[column.name] ? '' : listSupplierInfo?.[column.name]?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? listSupplierInfo?.[column.name] : listSupplierInfo?.['country'] && listSupplierInfo?.['country'].toLowerCase() === 'united states' && listSupplierInfo?.[column.name].startsWith('1') ? listSupplierInfo?.[column.name] : ((listSupplierInfo?.['country'] && listSupplierInfo?.['country'].toLowerCase() !== 'united states')) ? listSupplierInfo?.[column.name] : listSupplierInfo?.[column.name].startsWith('1') ? listSupplierInfo?.[column.name] : '1 ' + listSupplierInfo?.[column.name]

                tmpBasicInfo = {
                    ...tmpBasicInfo,
                    [column.name]: {
                        label: phone || '',
                        value: phone || ''
                    }
                }

                tmpChildBasicInfo = {
                    ...tmpChildBasicInfo,
                    [column.name]: {
                        label: listSupPhone || '',
                        value: listSupPhone || ''
                    }
                }
            } else {
                tmpBasicInfo = {
                    ...tmpBasicInfo,
                    [column.name]: {
                        label: supplierBasicInfo?.[column.name] || '',
                        value: supplierBasicInfo?.[column.name] || '',
                    }
                }
                tmpChildBasicInfo = {
                    ...tmpChildBasicInfo,
                    [column.name]: {
                        label: listSupplierInfo?.[column.name] || '',
                        value: listSupplierInfo?.[column.name] || '',
                    }
                }
            }
        })

        // tmpBasicInfo["id"] = supplierBasicInfo?.['id']
        setBasicInfo(tmpBasicInfo)
        setCallBasicInfo(tmpChildBasicInfo)
    }, [])

    const setInitialSupplierCardInfo = useCallback(async (columns, listMasterInfo, callData, selectedInfo) => {
        const callInfo = selectedInfo?.value === 'call' ? callData?.cardInfo : listMasterInfo?.cardInfo
        const cardEmails = selectedInfo?.value === 'call' ? callData?.cardEmails : listMasterInfo?.cardEmails
        if (cardEmails?.length > 0) {
            getEmailValues(cardEmails)
        }

        setShowAcceptancePerCard(callInfo?.isAcceptAcceptancePerCard)
        setGenericFeeValues({
            ...genericFeeValues,
            'showCreditCards': (callInfo?.isAcceptAmericanExpress === null && callInfo?.isAcceptMasterCard === null && callInfo?.isAcceptVisa === null) ? null : (callInfo?.isAcceptAmericanExpress && callInfo?.isAcceptMasterCard && callInfo?.isAcceptVisa) ? true : false,
            'processingFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexProcessingFeeType || '$',
            'processingFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexProcessingFeeValue,
            'processingSecondFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexSecondProcessingFeeType || '$',
            'processingSecondFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexSecondProcessingFeeValue,
            'minFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexMinPaymentFeeType || '$',
            'minFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexMinPaymentFeeValue,
            'maxFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexMaxPaymentFeeType || '$',
            'maxFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexMaxPaymentFeeValue,
            'incrementalFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexIncrementalFeeType || '$',
            'incrementalFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexIncrementalFeeValue,
            'minPayment': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.americanExpressMinPaymnet,
            'maxPayment': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.americanExpressMaxPayment,
            'incrementalPayment': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexIncrementalPaymentAmount,
            'showMinFee': callInfo?.isAcceptAcceptancePerCard ? false : callInfo?.amexMinPaymentFeeValue ? true : false,
            'showMaxFee': callInfo?.isAcceptAcceptancePerCard ? false : callInfo?.amexMaxPaymentFeeValue ? true : false,
            'showIncrementalFee': callInfo?.isAcceptAcceptancePerCard ? false : callInfo?.amexIncrementalFeeValue ? true : false,
            'showAnotherProcessingFee': callInfo?.isAcceptAcceptancePerCard ? false : callInfo?.amexSecondProcessingFeeValue ? true : false,
            'showVariableFee': (callInfo?.isAcceptAmexVariableFee === null && callInfo?.isAcceptMasterCardVariableFee === null && callInfo?.isAcceptVisaVariableFee === null) ? null : (callInfo?.isAcceptAmexVariableFee && callInfo?.isAcceptMasterCardVariableFee && callInfo?.isAcceptVisaVariableFee) ? true : false
        })

        callInfo?.isAcceptAcceptancePerCard ? setAccPerCardText('Generic Fee Structure') : setAccPerCardText('Acceptance Per Card')
    }, [])

    const getEmailValues = async (cardEmails) => {
        const isEmailValid = async (email) => {
            var valid = await handleEmailFocusOut(email, '', true);
            return valid
        }
        const getEmails = async () => {
            var emailarray = []
            if (cardEmails?.length > 0) {
                let allAddedEmails = cardEmails;
                emailarray = await Promise.all(
                    allAddedEmails.map(async (item, ind) => {
                        var index = 'extra-email-name-' + (ind + 1)
                        var valid = await isEmailValid(item.email);
                        return {
                            [index]: {
                                'email': item.email,
                                'emailType': item.emailType,
                                'valid': valid?.valid
                            }
                        }
                    })
                )
            }
            return emailarray
        };

        let emailValuesArray = await getEmails();
        setEmailValues(emailValuesArray);
    }

    useEffect(() => {
        if (!createSupplierBasicColumns || createSupplierBasicColumns.length === 0) {
            return
        }
    }, [listMasterData, callData, setInitialSupplierInfo])

    // initial card info
    useEffect(() => {
        if (!createSupplierCardColumns || createSupplierCardColumns.length === 0) {
            return
        }
        setInitialSupplierCardInfo(createSupplierCardColumns, listMasterData, callData, selectedInfo)
    }, [listMasterData, callData, selectedInfo, setInitialSupplierCardInfo])

    const handleVendorDetailsClose = () => {
        onClose()
    }

    const handleClickTab = (tab) => {
        tab !== currentTab && setCurrentTab(tab)
    }

    const handleOnChangeInfo = (value) => {
        setSelectedInfo(value)
    }

    const handleCopyAllClick = async () => {
        if (currentTab === 'basic') {
            const basicInfo = selectedInfo?.value === 'call' ? callData?.baseInfo : listMasterData?.baseInfo
            if (basicInfo?.['email']) {
                handleEmailFocusOut(basicInfo?.['email'] || '', 'basic')
            }
            const tmpBasicInfo = { ...basicInfo }
            delete tmpBasicInfo.id
            setBasicInfo(tmpBasicInfo)
        } else if (currentTab === 'card') {
            const callInfo = selectedInfo?.value === 'call' ? callData?.cardInfo : listMasterData?.cardInfo
            setListMasterGenericFeeValues({
                ...listMasterGenericFeeValues,
                'showCreditCards': (callInfo?.isAcceptAmericanExpress === null && callInfo?.isAcceptMasterCard === null && callInfo?.isAcceptVisa === null) ? null : (callInfo?.isAcceptAmericanExpress && callInfo?.isAcceptMasterCard && callInfo?.isAcceptVisa) ? true : false,
                'processingFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexProcessingFeeType || '$',
                'processingFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexProcessingFeeValue,
                'processingSecondFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexSecondProcessingFeeType || '$',
                'processingSecondFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexSecondProcessingFeeValue,
                'minFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexMinPaymentFeeType || '$',
                'minFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexMinPaymentFeeValue,
                'maxFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexMaxPaymentFeeType || '$',
                'maxFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexMaxPaymentFeeValue,
                'incrementalFeeType': callInfo?.isAcceptAcceptancePerCard ? '$' : callInfo?.amexIncrementalFeeType || '$',
                'incrementalFeeValue': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexIncrementalFeeValue,
                'minPayment': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.americanExpressMinPaymnet,
                'maxPayment': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.americanExpressMaxPayment,
                'incrementalPayment': callInfo?.isAcceptAcceptancePerCard ? '' : callInfo?.amexIncrementalPaymentAmount,
                'showMinFee': callInfo?.isAcceptAcceptancePerCard ? false : callInfo?.amexMinPaymentFeeValue ? true : false,
                'showMaxFee': callInfo?.isAcceptAcceptancePerCard ? false : callInfo?.amexMaxPaymentFeeValue ? true : false,
                'showIncrementalFee': callInfo?.isAcceptAcceptancePerCard ? false : callInfo?.amexIncrementalFeeValue ? true : false,
                'showAnotherProcessingFee': callInfo?.isAcceptAcceptancePerCard ? false : callInfo?.amexSecondProcessingFeeValue ? true : false,
                'showVariableFee': (callInfo?.isAcceptAmexVariableFee === null && callInfo?.isAcceptMasterCardVariableFee === null && callInfo?.isAcceptVisaVariableFee === null) ? null : (callInfo?.isAcceptAmexVariableFee && callInfo?.isAcceptMasterCardVariableFee && callInfo?.isAcceptVisaVariableFee) ? true : false
            })
            var addedCardEmailsValues = {}
            if (emailValues.length > 0) {
                emailValues?.map((value, index) => {
                    if (typeof (value) !== 'undefined') {
                        addedCardEmailsValues[index] = value?.["extra-email-name-" + (index + 1)]
                    }
                })
            }
            setAddCardEmailValues(addedCardEmailsValues)
            setNewEmailValues(emailValues)
            setCardInfo(selectedInfo?.value === 'call' ? callData?.cardInfo : listMasterData?.cardInfo)
        } else if (currentTab === 'check') {
            setCheckInfo(selectedInfo?.value === 'call' ? callData?.paymentInfo : listMasterData?.paymentInfo)
        } else if (currentTab === 'ach') {
            const achInfo = selectedInfo?.value === 'call' ? callData?.paymentInfo : listMasterData?.paymentInfo
            if (achInfo?.['emailAch']) {
                handleEmailFocusOut(achInfo?.['emailAch'] || '', 'ach')
            }
            setAchInfo(achInfo)
        }
    }

    const handleFieldClick = (colName, value, type = '', emailIndex) => {
        if (currentTab === 'basic') {
            if (colName === 'email' && value) {
                handleEmailFocusOut(value, 'basic')
            }
            setBasicInfo({
                ...basicInfo,
                [colName]: value || ''
            })
        } else if (currentTab === 'card') {
            if (type === 'generic') {
                setListMasterGenericFeeValues({
                    ...listMasterGenericFeeValues,
                    [colName]: value
                })
                return
            }
            if (colName === 'email') {
                const emailExists = newEmailValues?.some(item => {
                    return item && Object.values(Object.values(item)[0])?.includes(value?.email)
                })
                if (!emailExists) {
                    var index = 'extra-email-name-' + (newEmailValues.length + 1)
                    var index1 = Object.keys(addCardEmailValues).length
                    let addedCardEmailsValues = { ...addCardEmailValues };
                    setNewEmailValues([...newEmailValues, { [index]: { 'email': value?.email, 'emailType': value?.emailType, valid: value?.valid } }]);
                    addedCardEmailsValues[index1] = {
                        'email': value?.email,
                        'emailType': value?.emailType,
                    }
                    setAddCardEmailValues(addedCardEmailsValues)
                } else {
                    toast.show({
                        title: 'Warning',
                        description: 'This Email already exists!',
                    })
                }
                return
            }
            setCardInfo({
                ...cardInfo,
                [colName]: value || ''
            })
        } else if (currentTab === 'check') {
            setCheckInfo({
                ...checkInfo,
                [colName]: value || ''
            })
        } else if (currentTab === 'ach') {
            if (colName === 'emailAch' && value) {
                handleEmailFocusOut(value, 'ach')
            }
            setAchInfo({
                ...achInfo,
                [colName]: value || ''
            })
        }
    }

    // to set same card acceptance values in case of genric fee structure
    const handleChangeGenericFeeInfo = (colname, value, cardColumnsArray, feeValueColumnName, cardFeeColumnsArray, type = null, colname2 = '', paymentCol = '', paymentColumnsArray = []) => {
        if (colname === 'isAccPerCard') {
            setShowListMasterAcceptancePerCard(value)
            value ?
                setListMasterAccPerCardText('Generic Fee Structure')
                :
                setListMasterAccPerCardText('Acceptance Per Card')
            setCardInfo({
                ...cardInfo,
                isAcceptAcceptancePerCard: value
            })
            return
        }
        let tmpCardInfo = { ...cardInfo }
        var feeValue = ''
        if (type === 'currency' || type === 'percent') {
            var temp = "";
            temp = value ? parseInt(value.replace(/\D/g, '')) : '';
            value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            if (type === 'currency') {
                if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(value)) {
                    value = value
                } else {
                    value = value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
                }
            }
            if (type === 'percent') {
                if (/^\d{0,2}(\.\d{0,2})?$/.test(value)) {
                    value = value
                } else {
                    value = value.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
                }
            }
        }

        if (value === '$' || value === '%') {
            feeValue = value === '%' ? listMasterGenericFeeValues?.[feeValueColumnName] && listMasterGenericFeeValues?.[feeValueColumnName]?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
                parseInt(listMasterGenericFeeValues?.[feeValueColumnName].replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
                : ''
                : listMasterGenericFeeValues?.[feeValueColumnName]

            setListMasterGenericFeeValues({
                ...listMasterGenericFeeValues,
                [colname]: value,
                [feeValueColumnName]: feeValue
            })

            cardFeeColumnsArray.map((cardFeeColumn) => {
                tmpCardInfo = {
                    ...tmpCardInfo,
                    [cardFeeColumn]: feeValue
                }
            })
        } else {
            if (colname2 !== '' && paymentCol !== '') {
                setListMasterGenericFeeValues({
                    ...listMasterGenericFeeValues,
                    [colname]: value,
                    [colname2]: false,
                    [paymentCol]: ''
                })
            } else if (colname2 !== '') {
                setListMasterGenericFeeValues({
                    ...listMasterGenericFeeValues,
                    [colname]: value,
                    [colname2]: false,
                })
            } else {
                setListMasterGenericFeeValues({
                    ...listMasterGenericFeeValues,
                    [colname]: value
                })
            }
            if (type === 'showHideFee') {
                return
            }
        }

        cardColumnsArray?.map((cardColumn) => {
            tmpCardInfo = {
                ...tmpCardInfo,
                [cardColumn]: value
            }
        })
        paymentColumnsArray?.map((cardColumn) => {
            tmpCardInfo = {
                ...tmpCardInfo,
                [cardColumn]: value
            }
        })
        setCardInfo(tmpCardInfo)
    }

    const handleUpdateBasicInfo = (colName, item, country, event) => {
        let tmpValue = item?.target?.value
        if (colName === 'state' || colName === 'country') {
            if (/^[a-zA-Z\s]+$/.test(item?.target?.value)) {
                tmpValue = item?.target?.value
            } else {
                tmpValue = item?.target?.value.match(/^[a-zA-Z\s]+/gi) ? item?.target?.value.match(/^[a-zA-Z\s]+/gi)[0] : ''
            }
        } else if (colName === 'fax') {
            tmpValue = item?.target?.value
            if (!item?.target?.value || /^([+]?[\s0-9]{3,})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(item?.target?.value)) {
                setIsBasicFaxValid(true)
            } else {
                setIsBasicFaxValid(false)
            }
        } else if (colName === 'phone') {
            var phoneValue = item.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '').replace(/[^\w\s]|[\s]/gi, '')
            var countrycode = country.dialCode + ' '
            if (phoneValue !== '') {
                phoneValue = countrycode + phoneValue
                setIsBasicPhoneValid('')
            } else {
                phoneValue = country.dialCode
                setIsBasicPhoneValid(true)
            }
            setBasicPhoneCountryCode(country.dialCode)
            tmpValue = phoneValue
        } else if (colName === 'zip') {
            if (/^\d{5}(-\d{4})?$/.test(item?.target?.value)) {
                tmpValue = item?.target?.value
            } else {
                tmpValue = item?.target?.value.match(/^\d{1,5}(-\d{0,4})?/gi) ? item?.target?.value.match(/^\d{1,5}(-\d{0,4})?/gi)[0] : ''
            }
        } else if (colName === 'naics') {
            tmpValue = item?.target?.value
            if (item?.target?.value === '' || item?.target?.value === undefined || /^(\d{5}|\d{6})?$/i.test(item?.target?.value)) {
                setIsNaicsValid(true)
            } else {
                setIsNaicsValid(false)
            }
        } else if (colName === 'sic') {
            tmpValue = item?.target?.value
            if (item?.target?.value === '' || item?.target?.value === undefined || /^\d{4}?$/i.test(item?.target?.value)) {
                setIsSicValid(true)
            } else {
                setIsSicValid(false)
            }
        } else if (colName === 'phoneExtension') {
            if (/^\d{20}$/.test(item?.target?.value)) {
                tmpValue = item?.target?.value
            } else {
                tmpValue = item?.target?.value.match(/^\d{1,20}/gi) ? item?.target?.value.match(/^\d{1,20}/gi)[0] : ''
            }
        } else if (colName === 'employerIdNumber') {
            if (item?.target?.value.length === 3 && item?.target?.value.includes('-')) {
                item.target.value = item?.target?.value.replaceAll('-', '')
            } else if (item?.target?.value.length === 2 || item?.target?.value.length === 3) {
                if (item?.target?.value.length === 3) {
                    item.target.value = item?.target?.value.substring(0, 2) + '-' + item?.target?.value.substring(2)
                } else {
                    item.target.value += '-'
                }
            }
            if (/^\d{2}(-\d{7})?$/.test(item?.target?.value)) {
                tmpValue = item?.target?.value
            } else {
                tmpValue = item?.target?.value.match(/^\d{1,2}(-\d{0,7})?/gi) ? item?.target?.value.match(/^\d{1,2}(-\d{0,7})?/gi)[0] : ''
            }
        } else if (colName === 'abbreviatedState') {
            let regex = /^[a-zA-Z\s]{2}$/
            let regex1 = /^[a-zA-Z\s]{1,2}/gi
            if (basicInfo?.country.value && (basicInfo?.country.value.trim().toLowerCase() === 'australia' || basicInfo?.country.value.trim().toLowerCase() === 'aus')) {
                regex = /^[a-zA-Z\s]{3}$/
                regex1 = /^[a-zA-Z\s]{1,3}/gi
            }
            if (regex.test(item?.target?.value)) {
                tmpValue = item?.target?.value.trim().toUpperCase()
            } else {
                tmpValue = item?.target?.value.trim().match(regex1) ? item?.target?.value.trim().match(regex1)[0].toUpperCase() : ''
            }
        }
        setBasicInfo({ ...basicInfo, [colName]: tmpValue })
    }

    const handleUpdateCardInfo = (colName, item, type = null, country = null, event = null, colName1 = '') => {
        var discountValue = ''
        if (type === 'hideFee') {
            setCardInfo({
                ...cardInfo,
                [colName]: item,
                [colName1]: ''
            })
            return
        }
        if (type === 'currency' || type === 'percent') {
            var temp = "";
            temp = parseInt(item.replace(/\D/g, ''));
            item = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            if (type === 'currency') {
                if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(item)) {
                    setCardInfo({
                        ...cardInfo,
                        [colName]: item
                    })
                } else {
                    setCardInfo({
                        ...cardInfo,
                        [colName]: item?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? item?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
                    })
                }
                return
            }
            if (type === 'percent') {
                if (/^\d{0,2}(\.\d{0,2})?$/.test(item)) {
                    setCardInfo({
                        ...cardInfo,
                        [colName]: item
                    })
                } else {
                    setCardInfo({
                        ...cardInfo,
                        [colName]: item?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? item?.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
                    })
                }
                return
            }
        }

        if (type === 'discounttype') {
            discountValue = item === 'Percentage' ? cardInfo?.cardDiscountValue && cardInfo?.cardDiscountValue?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
                parseInt(cardInfo?.cardDiscountValue.replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
                : ''
                : cardInfo?.cardDiscountValue

            setCardInfo({
                ...cardInfo,
                cardDiscountValue: discountValue,
                [colName]: item
            })
            return
        }

        if (type === 'fax') {
            if (item === '' || /^([+]?[\s0-9]{3,})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(item)) {
                setIsFaxValid(true)
            } else {
                setIsFaxValid(false)
            }
        }

        if (colName === 'emailType') {
            setcardEmailType(item)
            return
        }

        if (type === 'phone') {
            var phoneValue = item?.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '').replace(/[^\w\s]|[\s]/gi, '')
            var countrycode = country.dialCode + ' '
            if (phoneValue !== '') {
                phoneValue = countrycode + phoneValue
                colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid('') : setIsIVRPhoneValid('')
            } else {
                phoneValue = country.dialCode
                colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
            }
            colName === 'cardPaymentByPhoneValue' ? setCardPhoneCountryCode(country.dialCode) : setIVRCountryCode(country.dialCode)
            item = phoneValue
        }

        if (type === 'extension') {
            if (/^\d{20}$/.test(item)) {
                item = item
            } else {
                item = item?.match(/^\d{1,20}/gi) ? item?.match(/^\d{1,20}/gi)[0] : ''
            }
        }

        if (type === 'url') {
            if (item === '' || /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i.test(item)) {
                if (colName === 'thirdPartyPortalUrl') {
                    setIsThirdPartyPortalUrlValid(true)
                } else {
                    setIsPortalUrlValid(true)
                }
            } else {
                if (colName === 'thirdPartyPortalUrl') {
                    setIsThirdPartyPortalUrlValid(false)
                } else {
                    setIsPortalUrlValid(false)
                }
            }
        }

        setCardInfo({
            ...cardInfo,
            [colName]: item
        })
    }

    const handleUpdateCardFeeInfo = (colName, item, type, feeValueColumnName, feeValueType) => {
        var feeValue = ''
        if (type === 'showHideFee') {
            setCardFeeInfo({ ...cardFeeInfo, 'showHideFee': { ...cardFeeInfo?.showHideFee, [colName]: item } })
        } else if (type === 'hideFee') {
            setCardFeeInfo({ ...cardFeeInfo, 'showHideFee': { ...cardFeeInfo?.showHideFee, [feeValueColumnName]: false } })
            setCardInfo({
                ...cardInfo,
                [colName]: item
            })
        } else {
            if (item !== '$' && item !== '%') {
                var temp = "";
                temp = parseInt(item?.replace(/\D/g, ''));
                item = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
                if (feeValueType === '$') {
                    if (! /^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(item)) {
                        item = item?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? item?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
                    }
                } else {
                    if (! /^\d{0,2}(\.\d{0,2})?$/.test(item)) {
                        item = item?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? item?.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
                    }
                }
                setCardFeeInfo({ ...cardFeeInfo, 'feeValues': { ...cardFeeInfo?.feeValues, [colName]: item } })
            } else {
                feeValue = item === '%' ? cardInfo?.[feeValueColumnName] && cardInfo?.[feeValueColumnName]?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
                    parseInt(cardInfo?.[feeValueColumnName].replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
                    : ''
                    : cardInfo?.[feeValueColumnName]

                setCardInfo({
                    ...cardInfo,
                    [feeValueColumnName]: feeValue,
                    [colName]: item
                })
            }
        }
    }

    const handleUpdateCheckInfo = (colName, item, type = null) => {
        var discountValue = '';
        if (colName === 'isAcceptPaymentAddressFromCompanyAddress') {
            const tmpCheckInfo = { ...checkInfo }
            tmpCheckInfo['isAcceptPaymentAddressFromCompanyAddress'] = item
            tmpCheckInfo.checkAddress1 = basicInfo.address1
            tmpCheckInfo.checkAddress2 = basicInfo.address2
            tmpCheckInfo.checkCity = basicInfo.city
            tmpCheckInfo.checkState = basicInfo.state
            tmpCheckInfo.checkZip = basicInfo.zip
            tmpCheckInfo.checkCountry = basicInfo.country
            setCheckInfo(tmpCheckInfo)
            return
        }

        if (type === 'discounttype') {
            discountValue = item === 'Percentage' ? checkInfo?.cashDiscountValue && checkInfo?.cashDiscountValue?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
                parseInt(checkInfo?.cashDiscountValue.replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
                : ''
                : checkInfo?.cashDiscountValue

            setCheckInfo({
                ...checkInfo,
                cashDiscountValue: discountValue,
                [colName]: item
            })
            return
        }
        if (type === 'currency' || type === 'percent') {
            var temp = "";
            temp = parseInt(item?.replace(/\D/g, ''));
            item = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            if (type === 'currency') {
                if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(item)) {
                    setCheckInfo({
                        ...checkInfo,
                        [colName]: item
                    })
                } else {
                    setCheckInfo({
                        ...checkInfo,
                        [colName]: {
                            ...item,
                            value: item?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? item?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
                        }
                    })
                }
                return
            }
            if (type === 'percent') {
                if (/^\d{0,2}(\.\d{0,2})?$/.test(item)) {
                    setCheckInfo({
                        ...checkInfo,
                        [colName]: item
                    })
                } else {
                    setCheckInfo({
                        ...checkInfo,
                        [colName]: {
                            ...item,
                            value: item?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? item?.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
                        }
                    })
                }
                return
            }
        }

        setCheckInfo({
            ...checkInfo,
            [colName]: item
        })
    }

    const handleUpdateAchInfo = (colName, value) => {
        if (colName === 'bankAccountNumber') {
            if (/^\d{0,17}$/.test(value)) {
                setAchInfo({
                    ...achInfo,
                    [colName]: value,
                })
            } else {
                setAchInfo({
                    ...achInfo,
                    [colName]: value?.match(/^\d{0,17}/gi) ? value?.match(/^\d{0,17}/gi)[0] : ''
                })
            }
            return
        }
        if (colName === 'bankRoutingNumber') {
            if (/^\d{0,9}$/.test(value)) {
                setAchInfo({
                    ...achInfo,
                    [colName]: value,
                })
            } else {
                setAchInfo({
                    ...achInfo,
                    [colName]: value?.match(/^\d{0,9}/gi) ? value?.match(/^\d{0,9}/gi)[0] : ''
                })
            }
            return
        }

        if (colName === 'emailAch') {
            if (!value) {
                setIsAchEmailValid(true)
            } else {
                setIsAchEmailValid('')
            }
        }

        setAchInfo({
            ...achInfo,
            [colName]: value
        })
    }

    const handlePhoneNumberFocusOut = async (event, country, phoneValue, colName) => {
        var countryCode = country && country.dialCode
        var phoneValueWithCode = phoneValue
        var testPhone = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
        if (testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(testPhone)) {
            colName === 'phone' ? setIsBasicPhoneValid(false) : colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(false) : setIsIVRPhoneValid(false)
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        }

        if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
            return
        }
        if (phoneValue !== '') {
            colName === 'phone' ? setIsValidatingBasicPhone(true) : colName === 'cardPaymentByPhoneValue' ? setIsValidatingCardPhone(true) : setIsValidatingIVRPhone(true)
            phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
            colName === 'phone' ? setIsBasicPhoneValid(phoneValidationResult?.isPhoneValid) : colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(phoneValidationResult?.isPhoneValid) : setIsIVRPhoneValid(phoneValidationResult?.isPhoneValid)
            colName === 'phone' ? setIsValidatingBasicPhone(phoneValidationResult?.isValidatingPhone) : colName === 'cardPaymentByPhoneValue' ? setIsValidatingCardPhone(phoneValidationResult?.isValidatingPhone) : setIsValidatingIVRPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            colName === 'phone' ? setIsBasicPhoneValid(true) : colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
        }
    }

    const handleEmailFocusOut = async (emailValue, infoType = 'basic', isAddingEmail = false) => {
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            if (infoType === 'basic') {
                setIsBasicEmailValid(false);
                setIsBasicEmailRisky(false);
            } else if (infoType === 'card') {
                setIsEmailValid(false)
            } else if (infoType === 'ach') {
                setIsAchEmailValid(false)
            }
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }

        var valid = true;
        if (emailValue && emailValue !== '') {
            infoType && (infoType === 'basic' ? setIsValidatingBasicEmail(true) : infoType === 'card' ? setIsValidatingCardEmail(true) : setIsValidatingAchEmail(true))
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch)
            if (infoType === 'basic') {
                setIsBasicEmailValid(emailValidationResult?.isEmailValid)
                setIsValidatingBasicEmail(emailValidationResult?.isValidatingEmail)
                setIsBasicEmailRisky(emailValidationResult?.isEmailRisky)
            } else if (infoType === 'card') {
                setIsEmailValid(emailValidationResult?.isEmailValid)
                setIsValidatingCardEmail(emailValidationResult?.isValidatingEmail)
            } else if (infoType === 'ach') {
                setIsAchEmailValid(emailValidationResult?.isEmailValid)
                setIsValidatingAchEmail(emailValidationResult?.isValidatingEmail)
            }
        } else {
            infoType && (infoType === 'basic' ? setIsBasicEmailValid(true) : infoType === 'card' ? setIsEmailValid(true) : setIsAchEmailValid(true))
        }
        if (isAddingEmail) {
            return { valid }
        }
    }

    const handleOnAddEmails = (emailValues) => {
        setAddCardEmailValues(emailValues)
    }

    const handleOnAddedEmails = (addedEmailValues) => {
        setAddedEmailValues(addedEmailValues)
        setNewEmailValues(addedEmailValues)
        setcardEmailType('')
    }

    const handlePrimaryCardEmail = (primaryEmail) => {
        if (primaryEmail.length !== 0) {
            setSupplierPrimaryCardEmail(primaryEmail)
        } else {
            setSupplierPrimaryCardEmail('')
        }

        if (primaryEmail.length === 0) {
            setIsEmailValid(true)
        } else {
            setIsEmailValid('')
        }
    }

    const handleChangeFile = (file, type) => {
        type === 'card' ? setCardAuthorizationFormFile(file) : setAchInstructionFile(file)
    }

    const handleSave = async (type = 'save') => {
        var addedEmailsValues = {}

        if (newEmailValues.length > 0) {
            newEmailValues?.map((value, index) => {
                if (typeof (value) !== 'undefined') {
                    addedEmailsValues[index] = value?.["extra-email-name-" + (index + 1)]
                }
            })
        }
        const isBasicInfoValid = await checkBasicInfo()
        if (!isBasicInfoValid) {
            return
        }

        const isCheckInfoValid = await checkCheckInfo()

        if (!isCheckInfoValid) {
            return
        }

        const isAchInfoValid = await checkACHInfo()
        if (!isAchInfoValid) {
            return
        }

        const isCardInfoValid = await checkCardInfo(addedEmailsValues)
        if (!isCardInfoValid) {
            return
        }

        setIsSavingData(true)
        if (basicInfo && Object.keys(basicInfo)?.length) {
            await saveBasicInfo()
        }
        if (cardInfo && Object.keys(cardInfo)?.length) {
            await saveCardInfo()
        }
        if ((checkInfo && Object.keys(checkInfo)?.length) || (achInfo && Object.keys(achInfo)?.length)) {
            await savePaymenInfo()
        }

        if (type === 'complete') {
            await dispatch(linkUnlinkedCallToVendor(vendorInfo?.value, callDetails?.vendorsInCall?.id, callDetails?.id, callDetails?.vendorsInCall?.callsAttempted || 0)).then(async () => {
                await dispatch(removeUnlinkedSupplierCallDetails(callDetails?.id))
                await dispatch(updateUnlinkedCallSupplierDetails(vendorInfo?.value, callDetails?.id, callDetails?.vendorsInCall?.id))
            })
            setIsSavingData(false)
            onClose('complete')
        }
        setIsSavingData(false)
    }

    const checkBasicInfo = async () => {
        if (!basicInfo.suppliername || basicInfo.suppliername === '') {
            toast.show({
                title: 'Warning',
                description: 'Supplier Name shouldn\'t be empty!',
            })
            return
        }
        if (isValidatingBasicPhone) {
            toast.show({
                title: 'Warning',
                description: 'validating basic info phone number...!',
            })
            return false
        }
        if (isValidatingBasicEmail) {
            toast.show({
                title: 'Warning',
                description: 'validating general info email...!',
            })
            return false
        }

        if (!isBasicEmailValid && isBasicEmailValid !== '') {
            toast.show({
                title: 'Warning',
                description: 'Invalid General Email!'
            })
            return false
        }

        if (isBasicPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid General Info Phone Number!',
            })
            return false
        }

        if (!isBasicFaxValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid General Fax Number!',
            })
            return false
        }

        if (!isNaicsValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid NAICS Code. Must be atleast 5 or 6 digits long!.'
            })
            return false
        }

        if (!isSicValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid SIC Code. Must be atleast 4 digits long!.'
            })
            return false
        }

        if (basicInfo?.employerIdNumber && basicInfo?.employerIdNumber !== '') {
            // check that EIN is entered in valid format or not
            if (basicInfo?.employerIdNumber !== '' && !/^(\d{2}-\d{7})?$/.test(basicInfo?.employerIdNumber)) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid Employee Id Number. Must be 9 digit number formatted xx-xxxxxxx.'
                })
                return false
            }

            // check that if EIN already exists
            const isEINExists = await dispatch(checkEmployerIdNumberExists({
                employerIdNumber: basicInfo?.employerIdNumber
            }))
            if (isEINExists?.einCount && isEINExists?.einCount > 0) {
                toast.show({
                    title: 'Warning',
                    description: 'Employer Id Number : ' + basicInfo.employerIdNumber + ' already exists!'
                })
                return false
            }
        }

        if (basicInfo?.abbreviatedState && basicInfo?.abbreviatedState !== '') {
            let regex = /^[a-zA-Z\s]{2}$/
            let stateChars = '2'
            if (basicInfo?.country && (basicInfo?.country.trim().toLowerCase() === 'australia' || basicInfo?.country.trim().toLowerCase() === 'aus')) {
                regex = /^[a-zA-Z\s]{2,3}$/
                stateChars = '2 or 3'
            }
            if (!regex.test(basicInfo?.abbreviatedState.trim())) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid State. Must be ' + stateChars + ' characters long!'
                })
                return false
            }
        }
        return true
    }

    const checkCardInfo = async (addedEmailsValues) => {
        if (isValidatingCardPhone || isValidatingIVRPhone) {
            toast.show({
                title: 'Warning',
                description: 'validating card acceptance phone number...!',
            })
            return false
        }
        if (isValidatingCardEmail) {
            toast.show({
                title: 'Warning',
                description: 'validating card acceptance email...!',
            })
            return false
        }

        if (cardInfo?.['isAcceptCardPaymentByEmail'] && supplierPrimaryCardEmail !== '' && !cardEmailType) {
            toast.show({
                title: 'Warning',
                description: 'Please choose the Card Email Type from dropdown!'
            })
            return false
        }

        if (supplierPrimaryCardEmail !== '') {
            var addEmailValuesObject = {}

            if (Object.keys(newEmailValues).length > 0) {
                Object.keys(newEmailValues).map((key, index) => {
                    addEmailValuesObject[index] = newEmailValues[key]?.[`extra-email-name-${index + 1}`]?.email
                })
            }

            if (Object.keys(addCardEmailValues).length > 0) {
                Object.keys(addCardEmailValues).map((key, ind) => {
                    const index = Object.keys(addEmailValuesObject)?.length
                    addEmailValuesObject[index] = addCardEmailValues[key]?.email
                })
            }


            if (Object.values(addEmailValuesObject).includes(supplierPrimaryCardEmail)) {
                toast.show({
                    title: 'Warning',
                    description: 'Email Address is already added!',
                })
                return
            }

            if (!isEmailValid && isEmailValid !== '') {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid Email'
                })
                return
            }
            if (cardEmailType === '') {
                toast.show({
                    title: 'Warning',
                    description: 'Please choose the Email Type from dropdown!',
                })
                return
            }

            var newIndex = Object.keys(addedEmailsValues).length > 0 ? (parseInt(Object.keys(addedEmailsValues)[Object.keys(addedEmailsValues).length - 1]) + 1) : Object.keys(addedEmailsValues).length
            addedEmailsValues[newIndex] = {
                'email': supplierPrimaryCardEmail,
                'emailType': cardEmailType
            }
            setSupplierPrimaryCardEmail('')

            var newIndex = Object.keys(addCardEmailValues).length > 0 ? (parseInt(Object.keys(addCardEmailValues)[Object.keys(addCardEmailValues).length - 1]) + 1) : Object.keys(addCardEmailValues).length
            addCardEmailValues[newIndex] = {
                'email': supplierPrimaryCardEmail,
                'emailType': cardEmailType,
                'valid': true
            }

            handleOnAddEmails(addCardEmailValues)
        } else {
            if (cardInfo?.['isAcceptCardPaymentByEmail'] && Object.values(addedEmailsValues).filter(x => x).length === 0) {
                toast.show({
                    title: 'Danger',
                    description: 'Cannot save email acceptance without a valid email!',
                })
                return false
            }
        }
        var invalidEmail = false;
        var emptyEmailType = false;

        if (Object.keys(addCardEmailValues).length > 0) {
            Object.keys(addCardEmailValues).map((key, index) => {
                if (addCardEmailValues[key] && addCardEmailValues[key]?.email !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(addedEmailsValues[key]?.email)) {
                    invalidEmail = true
                    delete addCardEmailValues[key]
                    return false
                }
                if (addCardEmailValues[key] && addCardEmailValues[key]?.emailType === '') {
                    if (cardEmailType === '') {
                        emptyEmailType = true
                        return false
                    } else {
                        addCardEmailValues[key]['emailType'] = cardEmailType
                    }
                }
            })
        }

        if (invalidEmail) {
            toast.show({
                title: 'Warning',
                description: 'Card Email Address must be in email format!',
            })
            return false
        }

        if (emptyEmailType) {
            toast.show({
                title: 'Warning',
                description: 'Please choose the Card Email Type from dropdown!'
            })
            return false
        }

        if (isEmailValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Card Email!'
            })
            return false
        }
        if (isPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Card Phone Number!',
            })
            return false
        }
        if (!isFaxValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Card Fax Number!',
            })
            return false
        }
        if (!isThirdPartyPortalUrlValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Third Party Portal URL!',
            })
            return false
        }
        if (!isPortalUrlValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Portal URL!',
            })
            return false
        }
        if (isIVRPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid IVR Phone Number!',
            })
            return false
        }

        if (cardInfo?.['isAcceptCardPaymentByFax'] && !cardInfo?.['cardPaymentByFaxValue']) {
            toast.show({
                title: 'Danger',
                description: 'Cannot save fax acceptance without a valid fax!',
            })
            return false
        }
        if (cardInfo?.['isAcceptCardPaymentByPhone']) {
            if ((!cardInfo?.['isAcceptPOTSPhone'] && !cardInfo?.['isAcceptIVRPhone']) || (cardInfo?.['isAcceptPOTSPhone'] && (!cardInfo?.['cardPaymentByPhoneValue'] || cardPhoneCountryCode === cardInfo?.['cardPaymentByPhoneValue']))) {
                toast.show({
                    title: 'Danger',
                    description: 'Cannot save phone acceptance without a valid phone!',
                })
                return false
            }
            if (cardInfo?.['isAcceptIVRPhone'] && (!cardInfo?.['cardPaymentIVRPhone'] || ivrCountryCode === cardInfo?.['cardPaymentIVRPhone'])) {
                toast.show({
                    title: 'Danger',
                    description: 'Cannot save IVR phone acceptance without a valid phone!',
                })
                return false
            }
        }
        if (cardInfo?.['isAcceptCardPaymentByOnlinePortal'] && ((cardInfo?.['isAcceptPortal'] && !cardInfo?.['portalUrl']) || (cardInfo?.['isAccept3rdPartyPortal'] && !cardInfo?.['thirdPartyPortalUrl']))) {
            toast.show({
                title: 'Danger',
                description: 'Cannot save online acceptance without a valid website!',
            })
            return false
        }
        return true
    }

    const checkACHInfo = async () => {
        if (isValidatingAchEmail) {
            toast.show({
                title: 'Warning',
                description: 'validating Ach acceptance email...!',
            })
            return false
        }
        if (achInfo?.bankRoutingNumber && achInfo.bankRoutingNumber !== '' && !/^\d{9}$/.test(achInfo.bankRoutingNumber)) {
            toast.show({
                title: 'Warning',
                description: 'Bank Routing Number should be 9 digits!',
            })
            return false
        }
        if (!isAchEmailValid && isAchEmailValid !== '') {
            toast.show({
                title: 'Warning',
                description: 'Please enter Email for payment notification as email format!'
            })
            return false
        }
        return true
    }

    const checkCheckInfo = async () => {
        if (checkInfo?.checkState && checkInfo?.checkState !== '' && !/^[a-zA-Z\s]+$/.test(checkInfo?.checkState)) {
            toast.show({
                title: 'Warning',
                description: 'State must include only characters!',
            })
            return false
        }
        return true
    }

    const saveBasicInfo = async () => {
        if (!listMasterData?.baseInfo?.id) {
            await dispatch(createSupplierBasicInfo({ ...basicInfo, listSupplierId: vendorInfo?.value, vendorInCallsDetailsId: null }, vendorInfo?.value, null, listMasterData?.cardInfo?.id, listMasterData?.paymentInfo?.id)).then(res => {
                toast.show({
                    title: 'Success',
                    description: 'Supplier Basic Info created successfully!',
                })

                // set card info and payment info if not created already
                if (!listMasterData?.cardInfo?.id && !listMasterData?.paymentInfo?.id) {
                    setListMasterData({ ...listMasterData, baseInfo: res?.supplier, cardInfo: res?.cardInfo || {}, paymentInfo: res?.payment || {} })
                } else if (!listMasterData?.cardInfo?.id) {
                    setListMasterData({ ...listMasterData, baseInfo: res?.supplier, cardInfo: res?.cardInfo || {} })
                } else if (!listMasterData?.paymentInfo?.id) {
                    setListMasterData({ ...listMasterData, baseInfo: res?.supplier, paymentInfo: res?.payment || {} })
                } else {
                    setListMasterData({ ...listMasterData, baseInfo: res?.supplier })
                }
                setBasicInfo({ ...basicInfo, listSupplierId: vendorInfo?.value })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create Supplier Basic Info!',
                })
            })
        } else {
            await dispatch(updateSupplierBasicInfo({ ...basicInfo, listSupplierId: vendorInfo?.value, vendorInCallsDetailsId: null }, vendorInfo?.value)).then(res => {
                toast.show({
                    title: 'Success',
                    description: 'Supplier Basic Info updated successfully!',
                })
                setListMasterData({ ...listMasterData, baseInfo: res })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to update Supplier Basic Info!',
                })
            })
        }
    }

    const saveCardInfo = async () => {
        const cardData = {}
        var addedEmailsValues = {}

        Object.keys(cardInfo).forEach(key => {
            if (multiSelectColumns.includes(key) && typeof cardInfo?.[key] !== 'string') {
                const cardSelectOptions = cardInfo[key]?.map(option => option?.value)?.join(",")
                cardData[key] = cardSelectOptions
            } else {
                cardData[key] = cardInfo[key]
            }
        })

        let tmpCardData = { ...cardData, listSupplierId: vendorInfo?.value, vendorInCallsDetailsId: null }
        delete tmpCardData?.id

        if (cardAuthorizationFormFile && cardAuthorizationFormFile.name) {
            await dispatch(
                uploadCardAuthorizationFormFile(cardAuthorizationFormFile)
            ).then((response) => {
                toast.show({
                    title: 'Success',
                    description: response.data.message,
                })
                cardInfo.cardAuthorizationFormFile = response.data.generatename
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: "Unable to Upload Card Authorization File",
                })
                return
            })
        }
        if (!listMasterData?.cardInfo?.id) {
            await dispatch(createSupplierCardInfo(tmpCardData, [], vendorInfo?.value)).then(async (res) => {
                if (addCardEmailValues && Object.keys(addCardEmailValues).length > 0) {
                    const cardEmails = await dispatchEmailsData(addCardEmailValues, null, vendorInfo?.value)
                    var emailarray = {}

                    if (cardEmails?.length > 0) {
                        let allAddedEmails = cardEmails;
                        emailarray = await Promise.all(
                            allAddedEmails.map(async (item, ind) => {
                                var index = 'extra-email-name-' + (ind + 1)
                                return {
                                    [index]: {
                                        'email': item.email,
                                        'emailType': item.emailType,
                                        'valid': true
                                    }
                                }
                            })
                        )
                    }
                    setNewEmailValues(emailarray)
                }
                toast.show({
                    title: 'Success',
                    description: 'Supplier Card Info created successfully!',
                })
                setListMasterData({ ...listMasterData, cardInfo: res?.cardInfo })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create Supplier Card Info!',
                })
            })
        } else {
            await dispatch(updateSupplierCardInfo(tmpCardData, [], vendorInfo?.value, listMasterData?.cardInfo?.id)).then(async (res) => {
                if (addCardEmailValues && Object.keys(addCardEmailValues).length > 0) {
                    const cardEmails = await dispatchEmailsData(addCardEmailValues, null, vendorInfo?.value)
                    var emailarray = {}

                    if (cardEmails?.length > 0) {
                        let allAddedEmails = cardEmails;
                        emailarray = await Promise.all(
                            allAddedEmails.map(async (item, ind) => {
                                var index = 'extra-email-name-' + (ind + 1)
                                return {
                                    [index]: {
                                        'email': item.email,
                                        'emailType': item.emailType,
                                        'valid': true
                                    }
                                }
                            })
                        )
                    }
                    setNewEmailValues(emailarray)
                }
                toast.show({
                    title: 'Success',
                    description: 'Supplier Card Info updated successfully!',
                })
                setListMasterData({ ...listMasterData, cardInfo: res?.cardInfo })
            }).catch((err) => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to update Supplier Card Info!',
                })
            })
        }
    }

    const savePaymenInfo = async () => {
        if (achInstructionFile && achInstructionFile.name) {
            await dispatch(
                uploadAchInstruction(achInstructionFile)
            ).then((response) => {
                toast.show({
                    title: 'Success',
                    description: response.data.message,
                })
                achInfo.achInstructions = response.data.generatename
            })
        }
        let tmpPaymentInfo = { ...checkInfo, ...achInfo, listSupplierId: vendorInfo?.value, vendorInCallsDetailsId: null }
        delete tmpPaymentInfo.id

        if (!listMasterData?.paymentInfo?.id) {
            await dispatch(createSupplierPaymentInfo(tmpPaymentInfo, vendorInfo?.value)).then(res => {
                toast.show({
                    title: 'Success',
                    description: 'Supplier ACH Info created successfully!',
                })
                setListMasterData({ ...listMasterData, paymentInfo: res })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create Supplier ACH Info!',
                })
            })
        } else {
            await dispatch(updateSupplierPaymentInfo(tmpPaymentInfo, listMasterData?.paymentInfo?.id)).then(res => {
                toast.show({
                    title: 'Success',
                    description: 'Supplier ACH Info updated successfully!',
                })
                setListMasterData({ ...listMasterData, paymentInfo: res })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to update Supplier ACH Info!',
                })
            })
        }
    }

    const dispatchEmailsData = async (addEmailValues, supplierId, listSupplierId = null) => {
        const emails = await dispatch(
            addCardAcceptanceEmails({
                supplierId: supplierId,
                userId: id,
                cardEmailsData: {
                    addEmailValues
                },
                listSupplierId,
                supType: 'listSupplier',
                vendorInCallsDetailsId: null
            })
        ).then(cardEmails => {
            setAddCardEmailValues({})
            setcardEmailType('')
            return cardEmails
        }).catch(() => {
            return []
        })
        return emails
    }

    return (
        <Modal
            backdrop={'static'}
            className="link-to-vendor-details-modal m-5"
            show={show}
            size="xl"
            overflow={false}
            onClick={() => { !isSavingData && handleVendorDetailsClose() }}
            onHide={() => { !isSavingData && handleVendorDetailsClose() }}
        >
            <Modal.Header>
                <Modal.Title className='fw-bold text-black'>
                    Link Caller Details To Vendor
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex align-items-center mb-5 sticky-header position-sticky top-0 bg-white pb-3'>
                    <div className='d-flex flex-column w-25 gap-3'>
                        <h3 className='fw-bold text-blue mb-0'>Select Information</h3>
                        <Select
                            className="h4 mb-0 text-black flex-grow-1 unsucessful-reason-selector"
                            placeholder='Select info...'
                            options={infoOptions.map(option => {
                                return option
                            })}
                            value={selectedInfo}
                            onChange={(item) => { handleOnChangeInfo(item) }}
                        />
                    </div>
                    <h3 className='fw-bold text-black mb-0 ms-auto'>{vendorInfo?.label}</h3>
                </div>
                <div className='list-tabs d-flex align-items-end border border-top-0 border-start-0 border-end-0 border-1'>
                    {
                        tabs.map(tab => (
                            <button
                                key={tab.value}
                                type="button"
                                className={`h4 border border-1 border-bottom-0 rounded-top mb-0 page-tab list-tab pt-2 pb-2 p-4 text-black fw-bold me-3${currentTab === tab.value ? ' selected bg-dark-blue text-white pt-3 pb-3' : ''}`}
                                onClick={() => { handleClickTab(tab.value) }}
                            >
                                {tab.label}
                            </button>
                        ))
                    }
                </div>
                <div className={`${currentTab === 'basic' ? 'create-master-modal' : ''} p-0 border-0 position-relative`}>
                    <div className={`content ps-4 pe-4 position-relative${isSavingData ? ' loading' : ''}`}>
                        {isSavingData && <LoaderComponent />}
                        {currentTab === 'basic' && (
                            <BasicInfo
                                columns={createSupplierBasicColumns}
                                basicInfo={selectedInfo?.value === 'call' ? callData?.baseInfo : listMasterData?.baseInfo}
                                selectedBasicInfo={basicInfo}
                                onFieldClick={handleFieldClick}
                                onChangeBasicInfo={handleUpdateBasicInfo}
                                handleBasicInfoEmailFocusOut={handleEmailFocusOut}
                                isValidatingEmail={isValidatingBasicEmail}
                                isEmailValid={isBasicEmailValid}
                                isEmailRisky={isBasicEmailRisky}
                                handleBasicInfoPhoneNumberFocusOut={handlePhoneNumberFocusOut}
                                isPhoneValid={isBasicPhoneValid}
                                isValidatingPhone={isValidatingBasicPhone}
                            />
                        )}
                        {currentTab === 'card' && (
                            <div className='assign-vendor-supply assign-vendor-component p-0'>
                                <div className="supply-acceptance related-supply-acceptance flex-column">
                                    <CardInfo
                                        listMasterInfo={cardInfo}
                                        callInfo={callCardInfo}
                                        cardInfo={selectedInfo?.value === 'call' ? callData?.cardInfo : listMasterData?.cardInfo}
                                        selectedCardInfo={cardInfo}
                                        genericFeeValues={genericFeeValues}
                                        listMasterGenericFeeValues={listMasterGenericFeeValues}
                                        accPerCardText={accPerCardText}
                                        listMasterAccPerCardText={listMasterAccPerCardText}
                                        showAcceptancePerCard={showAcceptancePerCard}
                                        showListMasterAcceptancePerCard={showListMasterAcceptancePerCard}
                                        cardEmailType={cardEmailType}
                                        onFieldClick={handleFieldClick}
                                        onGenericFieldClick={handleChangeGenericFeeInfo}
                                        callEmailValues={emailValues}
                                        selectedDataEmailValues={newEmailValues}
                                        onChangeCardInfo={handleUpdateCardInfo}
                                        onUpdateCardFeeInfo={handleUpdateCardFeeInfo}
                                        cardFeeInfo={cardFeeInfo}
                                        onAddEmails={handleOnAddEmails}
                                        onPrimaryCardEmail={handlePrimaryCardEmail}
                                        onAddedEmails={handleOnAddedEmails}
                                        isEmailValid={isEmailValid}
                                        isValidatingEmail={isValidatingCardEmail}
                                        handleCardEmailFocusOut={handleEmailFocusOut}
                                        addedEmailValues={addedEmailValues}
                                        onChangeGenericFeeInfo={handleChangeGenericFeeInfo}
                                        isPhoneValid={isPhoneValid}
                                        isValidatingPhone={isValidatingCardPhone}
                                        isIVRPhoneValid={isIVRPhoneValid}
                                        isValidatingIVRPhone={isValidatingIVRPhone}
                                        handleCardPhoneNumberFocusOut={handlePhoneNumberFocusOut}
                                        onChangeCardAuthorizationFormFile={handleChangeFile}
                                        cardAuthorizationFormFile={cardAuthorizationFormFile}
                                        supplierPrimaryCardEmail={supplierPrimaryCardEmail}
                                    />
                                </div>
                            </div>
                        )}
                        {currentTab === 'check' && (
                            <div className='assign-vendor-supply assign-vendor-component p-0'>
                                <div className="supply-acceptance related-supply-acceptance flex-column">
                                    <CheckInfo
                                        checkInfo={selectedInfo?.value === 'call' ? callData?.paymentInfo : listMasterData?.paymentInfo}
                                        selectedCheckInfo={checkInfo}
                                        onFieldClick={handleFieldClick}
                                        onChangeCheckInfo={handleUpdateCheckInfo}
                                    />
                                </div>
                            </div>
                        )}
                        {currentTab === 'ach' && (
                            <div className='assign-vendor-supply assign-vendor-component p-0'>
                                <div className="supply-acceptance related-supply-acceptance flex-column">
                                    <AchInfo
                                        achInfo={selectedInfo?.value === 'call' ? callData?.paymentInfo : listMasterData?.paymentInfo}
                                        selectedAchInfo={achInfo}
                                        onFieldClick={handleFieldClick}
                                        onChangeAchInfo={handleUpdateAchInfo}
                                        isEmailValid={isAchEmailValid}
                                        isValidatingEmail={isValidatingAchEmail}
                                        handleAchEmailFocusOut={handleEmailFocusOut}
                                        onChangeAchInstructionFile={handleChangeFile}
                                        achInstructionFile={achInstructionFile}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className='d-flex gap-3 justify-content-end ps-4 position-sticky bottom-0'>
                <button
                    className='width-100 bg-yellow rounded p-3 text-white h4 mb-0'
                    onClick={() => { handleCopyAllClick() }}
                    disabled={isSavingData}
                >
                    Copy all
                </button>
                <button
                    className='width-100 bg-blue rounded p-3 text-white h4 mb-0'
                    onClick={() => { handleSave() }}
                    disabled={isSavingData}
                >
                    Save
                </button>
                <button
                    className='width-100 bg-green rounded p-3 text-white h4 mb-0'
                    onClick={() => { handleSave('complete') }}
                    disabled={isSavingData}
                >
                    Complete
                </button>
            </Modal.Footer>
        </Modal >
    )

}

export default LinkToVendorDetailsModal